var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg049Like(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19 7.00001H16V3.00001C16 2.13915 15.4491 1.37487 14.6325 1.10264C13.8158 0.830412 12.9165 1.11132 12.4 1.80001L8.5 7.00001H6C5.44772 7.00001 5 7.44772 5 8.00001V17C5 17.5523 5.44772 18 6 18H16.7C17.8847 17.9997 18.9582 17.3023 19.44 16.22L21.7 11.15C22.0957 10.2334 22.0094 9.18006 21.47 8.34001C20.9285 7.50191 19.9978 6.99696 19 7.00001ZM19.87 10.33L17.61 15.41C17.4489 15.7684 17.0929 15.9992 16.7 16H7V9.00001H9C9.31476 9.00001 9.61115 8.85181 9.8 8.60001L14 3.00001V8.00001C14 8.55229 14.4477 9.00001 15 9.00001H19C19.3201 9.00699 19.6176 9.16686 19.8 9.43001C19.9651 9.70181 19.9911 10.0359 19.87 10.33ZM2 17V8.00001C2 7.44772 2.44772 7.00001 3 7.00001C3.55228 7.00001 4 7.44772 4 8.00001V17C4 17.5523 3.55228 18 3 18C2.44772 18 2 17.5523 2 17Z",
    fill: "#8199A6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg049Like);
export default __webpack_public_path__ + "static/media/049-like.324ad004425165d3ace016aab0e7a1e8.svg";
export { ForwardRef as ReactComponent };